import Flickity from 'flickity';
import 'flickity-imagesloaded';

import { on, off } from '@pwup/core/listener';
import win from '@pwup/core/window';
import { query } from '@pwup/dom/query';
import Breakpoint from '@pwup/events/breakpoint';

import { BREAKPOINT_MD, BREAKPOINT_LG } from '../../breakpoints';

const CAROUSEL_OPTIONS = {
  accessibility: false,
  adaptiveHeight: false,
  cellAlign: 'left',
  cellSelector: '.product-picks__slide',
  contain: true,
  draggable: true,
  groupCells: true,
  imagesLoaded: true,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: false,
};

class ProductPicks {
  constructor(el) {
    this.el = el;
    this.carousel = query('.product-picks__slider', this.el);
    this.previousBtn = query('.product-picks__arrowLeft', this.el);
    this.nextBtn = query('.product-picks__arrowRight', this.el);

    this._group = null;

    this._onNext = this._onNext.bind(this);
    this._onPrevious = this._onPrevious.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onBreakpoint = this._onBreakpoint.bind(this);

    this.init();
  }

  init() {
    this.bp = new Breakpoint([
      `(min-width: ${BREAKPOINT_MD}px)`,
      `(min-width: ${BREAKPOINT_LG}px)`,
    ], this._onBreakpoint);

    this.bp.run();
  }
  destroy() {
    if( this.flickity ) this.flickity.destroy();
    if( this.bp ) this.bp.dispose();

    this.el = null;
    this.carousel = null;
    this.previousBtn = null;
    this.nextBtn = null;
    this.flickity = null;

    this._onNext = null;
    this._onPrevious = null;
    this._onChange = null;
    this._onBreakpoint = null;
  }

  start() {
    if( this.previousBtn ) on(this.previousBtn, 'click', this._onPrevious);
    if( this.nextBtn ) on(this.nextBtn, 'click', this._onNext);
    if( this.flickity ) {
      this.flickity.on('change', this._onChange);
      this._onChange(this.flickity.selectedIndex);
    }
    if( this.bp ) this.bp.on();
  }
  stop() {
    if( this.bp ) this.bp.off();
    if( this.previousBtn ) off(this.previousBtn, 'click', this._onPrevious);
    if( this.nextBtn ) off(this.nextBtn, 'click', this._onNext);
    if( this.flickity ) this.flickity.off('change', this._onChange);
  }

  _setFlickity() {
    if( this.carousel ) {
      this.flickity = new Flickity(this.carousel, {
        ...CAROUSEL_OPTIONS,
        ...{ groupCells: this._group },
      });
    }
  }
  _onNext() {
    if( this.flickity ) this.flickity.next();
  }
  _onPrevious() {
    if( this.flickity ) this.flickity.previous();
  }
  _onChange(index) {
    if( this.previousBtn ) {
      if( index === 0 ) this.previousBtn.setAttribute('disabled', true);
      else this.previousBtn.removeAttribute('disabled');
    }

    if( this.nextBtn ) {
      if( index === this.flickity.slides.length - 1 ) this.nextBtn.setAttribute('disabled', true);
      else this.nextBtn.removeAttribute('disabled');
    }
  }
  _onBreakpoint() {
    const vw = win.width;
    let group = null;

    if( vw >= BREAKPOINT_LG ) group = 4;
    else if( vw >= BREAKPOINT_MD ) group = 3;
    else group = 2;

    if( group !== this._group ) {
      this._group = group;

      this.stop();
      this._setFlickity();
      this.start();
    }
  }
}

export default ProductPicks;
